import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getMessaging, getToken, onMessage, MessagePayload } from 'firebase/messaging';
import {
  firebaseConfigProjectId,
  firebaseConfigApiKey,
  firebaseConfigAuthDomain,
  firebaseConfigDatabaseURL,
  firebaseConfigStorageBucket,
  firebaseConfigMessagingSenderId,
  firebaseConfigAppId,
  firebaseConfigMeasurementId,
  firebaseVapidKey,
} from '../../constants/configuration';

const firebaseConfig = {
  apiKey: firebaseConfigApiKey,
  authDomain: firebaseConfigAuthDomain,
  databaseURL: firebaseConfigDatabaseURL,
  projectId: firebaseConfigProjectId,
  storageBucket: firebaseConfigStorageBucket,
  messagingSenderId: firebaseConfigMessagingSenderId,
  appId: firebaseConfigAppId,
  measurementId: firebaseConfigMeasurementId,
};

export const firebaseApp: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const messaging = typeof navigator !== 'undefined' && navigator.serviceWorker ? getMessaging(firebaseApp) : null;

export const initFirebaseAnalytics = () => {
  if (!firebaseConfigMeasurementId) {
    return;
  }

  isSupported()
    .then((supported) => {
      if (supported) {
        getAnalytics(firebaseApp);
      }
    })
    .catch(() => undefined);
};

export const getNotificationToken = (setTokenFound: (token: string | null) => void) => {
  if (!messaging) {
    return setTokenFound(null);
  }

  return getToken(messaging, {
    vapidKey: firebaseVapidKey,
  })
    .then((currentToken) => {
      if (currentToken) {
        setTokenFound(currentToken);
      } else {
        setTokenFound(null);
      }
    })
    .catch(() => {
      setTokenFound(null);
    });
};

export const onMessageListener = () =>
  new Promise<MessagePayload | null>((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }

    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
